import React, { useEffect } from 'react';
import {
  SuccessToastBody,
  ErrorToastBody,
  Check,
  Error,
  Close,
  DesktopMessage,
  MobileMessage,
} from '@gcc/countertops-components/dist/Toast/styles';
import Toast, { notify } from '@gcc/countertops-components/dist/Toast';
import { ToastWrapper, ToastBodyWrapper } from './styles';

const desktop = '767px';
const mobile = '768px';

const desktopMessage = (msg) => (
  <DesktopMessage desktop={desktop}>
    <b>{msg}</b>
  </DesktopMessage>
);

const mobileMessage = (msg) => (
  <MobileMessage mobile={mobile}>
    <b>{msg}</b>
  </MobileMessage>
);

export const OrderSummaryToastSuccess = () => (
  <ToastBodyWrapper>
    <SuccessToastBody>
      <Check />
      {mobileMessage('Added to Bundle')}
      {desktopMessage('Added to Bundle')}
      <Close
        onClick={() => {
          notify();
        }}
      />
    </SuccessToastBody>
  </ToastBodyWrapper>
);

export const OrderSummaryToastError = (message) => (
  <ToastBodyWrapper>
    <ErrorToastBody style={{ marginTop: 10 }}>
      <Error />
      {mobileMessage(message)}
      {desktopMessage(message)}
      <Close
        onClick={() => {
          notify();
        }}
      />
    </ErrorToastBody>
  </ToastBodyWrapper>
);

export const showSuccessToast = () => {
  notify(OrderSummaryToastSuccess(), 3000);
};
export const showErrorToast = () => {
  notify(OrderSummaryToastError(), 3000);
};

export const OrderSummaryToastPlaceholder = () => {
  useEffect(() => {
    const target = document.getElementById('toast-wrapper');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        target.style.marginTop = target.offsetHeight > 0 ? '15px' : 0;
        target.style.marginBottom = target.offsetHeight > 0 ? '-10px' : '-7px';
      });
    });

    if (target?.firstChild) {
      observer.observe(target.firstChild, { attributes: true, attributeFilter: ['class'] });
    }
  }, []);
  return (
    <ToastWrapper id="toast-wrapper">
      <Toast />
    </ToastWrapper>
  );
};
